import script from "./ManageAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./ManageAnnouncements.vue?vue&type=style&index=0&id=b7b315d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b315d4"]])

export default __exports__